import apiClient from "./apiClient";

const listingFaqsEndpoint = "/listing-faqs";

// `page`: { department, city, zone, operation } (ver listing-faqs-constants)
const toPageParams = ({ department, city, zone, operation }) => ({
  department,
  operation,
  ...(city && { city }),
  ...(zone && { zone }),
});

export const getListingFaqs = async (page) =>
  apiClient
    .get(listingFaqsEndpoint, { params: toPageParams(page) })
    .then((res) => res.data.faqs);

export const getPagesWithListingFaqs = async () =>
  apiClient.get(`${listingFaqsEndpoint}/pages`).then((res) => res.data.pages);

export const createListingFaq = async (page, { question, answer }) =>
  apiClient
    .post(listingFaqsEndpoint, { ...toPageParams(page), question, answer })
    .then((res) => res.data.faq);

export const updateListingFaq = async (id, { question, answer }) =>
  apiClient
    .put(`${listingFaqsEndpoint}/${id}`, { question, answer })
    .then((res) => res.data.faq);

export const deleteListingFaq = async (id) =>
  apiClient.delete(`${listingFaqsEndpoint}/${id}`).then((res) => res.data);

export const reorderListingFaqs = async (page, ids) =>
  apiClient
    .put(`${listingFaqsEndpoint}/reorder`, { ...toPageParams(page), ids })
    .then((res) => res.data.faqs);
